module.exports = __webpack_public_path__ + "img/bannerTestEgresado.3fb1413c.jpg";